import React from 'react'
import {RadioCircle} from '../../../../accountManagement/shared/RadioCircle'
import {
  DownArrowIcon,
  PlanArrowIcon,
} from '../../../../accountManagement/shared/icons'
import {getProductIcon} from '../../../../core/shared/ProductIcons'
import {currencyFormat} from '../../../../utils/currency-format'
import {QuantityStepper} from '../QuantityStepper'
import {OptionsSelector} from '../OptionsSelector'
import {CARD_VARIANTS} from '../../utils/cardVariants'
import {
  CardWrapper,
  CardHeader,
  CardIcon,
  CardIconImage,
  CardName,
  CardDescription,
  CardFooter,
  CardPrice,
  CardAction,
  ArrowWrapper,
} from './ProductGroupCard.styles'

export function ProductGroupCard({
  name,
  description,
  price,
  selectedCountry,
  billingPeriod = 'monthly',
  isSelected = false,
  isAdded = false,
  isDimmed = false,
  disabled = false,
  onSelect,
  onAddToOrder,
  cardVariant = CARD_VARIANTS.VIEW_CONFIGURATION,
  showPrice = true,
  quantity = 0,
  minQuantity = 0,
  maxQuantity = null,
  displayQuantity,
  displayMultiplier = 1,
  onIncrement,
  onDecrement,
  onQuantityInput,
  options = null,
  selectedOption = null,
  onOptionChange,
}) {
  const isAddToOrder = cardVariant === CARD_VARIANTS.DIRECT_ADD_TO_ORDER
  const isStepper = cardVariant === CARD_VARIANTS.DIRECT_STEPPER
  const isOptionsSelector =
    cardVariant === CARD_VARIANTS.DIRECT_OPTIONS_SELECTOR

  const onRadioClick = isAddToOrder
    ? onAddToOrder
    : !isStepper && !isOptionsSelector
    ? onSelect
    : undefined

  return (
    <CardWrapper
      isSelected={isSelected}
      isDimmed={isDimmed}
      onClick={onRadioClick}
    >
      <CardHeader>
        <CardIcon>
          <CardIconImage src={getProductIcon(name)} alt="" />
        </CardIcon>
        <CardName>{name}</CardName>
        <RadioCircle active={isAdded || isSelected} />
      </CardHeader>
      {description && <CardDescription>{description}</CardDescription>}
      <CardFooter hasPrice={showPrice}>
        {showPrice && (
          <CardPrice>
            {currencyFormat(price, selectedCountry)}
            {billingPeriod !== 'one_time' && (
              <span>{billingPeriod === 'annual' ? '/yr' : '/mo'}</span>
            )}
          </CardPrice>
        )}
        {isStepper ? (
          <QuantityStepper
            quantity={quantity}
            min={minQuantity}
            maxQuantity={maxQuantity}
            displayValue={displayQuantity}
            displayMultiplier={displayMultiplier}
            label={`${name} quantity`}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            onQuantityInput={onQuantityInput}
          />
        ) : isOptionsSelector ? (
          <OptionsSelector
            options={options}
            selectedValue={selectedOption?.value ?? null}
            onChange={onOptionChange}
          />
        ) : isAddToOrder ? (
          <CardAction
            type="button"
            onClick={e => {
              e.stopPropagation()
              onAddToOrder()
            }}
            disabled={disabled}
          >
            <PlanArrowIcon />
            Add to Order
          </CardAction>
        ) : (
          <CardAction
            type="button"
            onClick={e => {
              e.stopPropagation()
              onSelect()
            }}
          >
            View Configuration
            <ArrowWrapper isExpanded={isSelected}>
              <DownArrowIcon />
            </ArrowWrapper>
          </CardAction>
        )}
      </CardFooter>
    </CardWrapper>
  )
}
